
import UtilsFormule from "../../../utils/UtilsFormule";
import UtilsUrl from "../../../utils/UtilsUrl";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import UtilsFormuleSell from "../../../utils/UtilsFormuleSell";



const PrelevementPayementDetails = ({ payementAvance }) => {



    const onShowFileInOtherWizndowHandler = (path) => {
        uploadAndDownloadService
            .downloadFile(path)
            .then((response) => {
                // let index = path.lastIndexOf(".");
                // let extension = path.substr(index + 1);

                //Build a URL from the file
                if (response.headers["content-type"] === "image/png") {
                    const file = new Blob([response.data], { type: "image/png" });
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                } else if (response.headers["content-type"] === "application/pdf") {
                    const file = new Blob([response.data], { type: "application/pdf" });
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                } else if (response.headers["content-type"] === "image/jpeg") {
                    const file = new Blob([response.data], { type: "image/jpeg" });
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                } else if (response.headers["content-type"] === "image/jpg") {
                    const file = new Blob([response.data], { type: "image/jpg" });
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                }
            })
            .catch(() => {
                // setOpenErrorAlert(true);
                // setErrorAlertText("Erreur : il ya un probléme de connection");
            });
    };

    return (
        <div className="row">
            <div className="user-block">
                Payement par <b> Prélevement </b> le {UtilsFormule.formatDate(payementAvance?.creationDate)}
                <br />
                Montant payée:{payementAvance?.amountPayed} TND
                <br />
                {UtilsFormuleSell.TypePayementValidation(payementAvance)}
                <br />
            </div></div>
    )



}
export default PrelevementPayementDetails;